// AppButton.tsx
import React, { useState } from 'react';
import AppGetIcon from './../../AppGetIcon';
import styleDataTable from '../../../../common/UI/DataTable/dataTable.module.css';
import styles from './AppButton.module.css';

interface AppButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  iconName?: string;
  buttonText?: string;
  variant?: 'filled' | 'outlined' | 'text' | 'tonal' | 'elevated' | 'primary' | 'secondary' | '';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  unsetWidth?: boolean;
  isIconOnly?: boolean;
  tooltipText?: string;
  isborderRadiosOval?: boolean;
}

const AppButton: React.FC<AppButtonProps> = ({
  onClick,
  iconName,
  buttonText,
  variant = 'filled',
  size = 'medium',
  unsetWidth = false,
  disabled = false,
  isIconOnly = false,
  tooltipText,
  ...rest
}) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  // 💡 Mapear variantes personalizadas
  const mappedVariant =
    variant === 'primary'
      ? 'filled'
      : variant === 'secondary'
      ? 'tonal'
      : variant;

  const iconOnlyMode = isIconOnly || (iconName && !buttonText);

  const baseClass = `${styles.button_base} ${styles[mappedVariant]} ${styles[size]}`;
  const iconOnlyClass = iconOnlyMode ? styles.icon_only : '';
  const disabledClass = disabled ? styles.disabled : '';
  const unsetWidthClass = unsetWidth ? styles.unset_width : '';

  return (
    <div
      style={{
        position: 'relative',
        width: unsetWidth ? 'auto' : '100%',
        display: 'inline-block'
      }}
    >
      <button
        className={`${baseClass} ${iconOnlyClass} ${disabledClass} ${unsetWidthClass}`}
        onClick={!disabled ? onClick : undefined}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        disabled={disabled}
        aria-label={tooltipText ?? buttonText}
        {...rest}
      >
        {iconName && (
          <AppGetIcon
            name={iconName}
            classIcon={styleDataTable.sizeIcon}
          />
        )}
        {!iconOnlyMode && buttonText && (
          <span className={styles.button_text}>{buttonText}</span>
        )}
      </button>

      {tooltipText && isHovered && (
        <span className={styles.tooltip}>{tooltipText}</span>
      )}
    </div>
  );
};

export default AppButton;